export const TENCENT_QUOTE_URL = "https://qt.gtimg.cn/";
export const TENCENT_SEARCH_URL = "https://smartbox.gtimg.cn/s3/";
export const TENCENT_NAV_HISTORY_URL =
  "https://stockjs.finance.qq.com/fundUnitNavAll/data/year_all";
